export default __webpack_public_path__ + "static/media/Lateral_tilt_angle.1a72aa3f.svg";